import React from "react";
import { IconProps } from "./IconProps";

const LinkedinLogoIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6442 1.875H3.10577C2.77935 1.875 2.4663 2.00467 2.23548 2.23548C2.00467 2.4663 1.875 2.77935 1.875 3.10577V16.6442C1.875 16.9707 2.00467 17.2837 2.23548 17.5145C2.4663 17.7453 2.77935 17.875 3.10577 17.875H16.6442C16.9707 17.875 17.2837 17.7453 17.5145 17.5145C17.7453 17.2837 17.875 16.9707 17.875 16.6442V3.10577C17.875 2.77935 17.7453 2.4663 17.5145 2.23548C17.2837 2.00467 16.9707 1.875 16.6442 1.875ZM16.6442 16.6442H3.10577V3.10577H16.6442V16.6442ZM7.41346 8.64423V13.5673C7.41346 13.7305 7.34863 13.887 7.23322 14.0025C7.11781 14.1179 6.96129 14.1827 6.79808 14.1827C6.63487 14.1827 6.47834 14.1179 6.36293 14.0025C6.24753 13.887 6.18269 13.7305 6.18269 13.5673V8.64423C6.18269 8.48102 6.24753 8.3245 6.36293 8.20909C6.47834 8.09368 6.63487 8.02885 6.79808 8.02885C6.96129 8.02885 7.11781 8.09368 7.23322 8.20909C7.34863 8.3245 7.41346 8.48102 7.41346 8.64423ZM14.1827 10.7981V13.5673C14.1827 13.7305 14.1179 13.887 14.0025 14.0025C13.887 14.1179 13.7305 14.1827 13.5673 14.1827C13.4041 14.1827 13.2476 14.1179 13.1322 14.0025C13.0168 13.887 12.9519 13.7305 12.9519 13.5673V10.7981C12.9519 10.3901 12.7898 9.99874 12.5013 9.71022C12.2128 9.4217 11.8215 9.25962 11.4135 9.25962C11.0054 9.25962 10.6141 9.4217 10.3256 9.71022C10.0371 9.99874 9.875 10.3901 9.875 10.7981V13.5673C9.875 13.7305 9.81017 13.887 9.69476 14.0025C9.57935 14.1179 9.42283 14.1827 9.25962 14.1827C9.09641 14.1827 8.93988 14.1179 8.82447 14.0025C8.70907 13.887 8.64423 13.7305 8.64423 13.5673V8.64423C8.64499 8.4935 8.70106 8.34828 8.80178 8.23614C8.9025 8.124 9.04088 8.05272 9.19067 8.03584C9.34046 8.01895 9.49124 8.05763 9.6144 8.14453C9.73756 8.23144 9.82454 8.36053 9.85885 8.50731C10.2751 8.2249 10.7605 8.06123 11.2628 8.03386C11.7651 8.00649 12.2654 8.11647 12.7099 8.35197C13.1544 8.58747 13.5264 8.93961 13.7859 9.37057C14.0453 9.80153 14.1825 10.295 14.1827 10.7981ZM7.72115 6.49038C7.72115 6.67295 7.66702 6.85142 7.56559 7.00322C7.46416 7.15502 7.31999 7.27333 7.15132 7.3432C6.98265 7.41306 6.79705 7.43134 6.61799 7.39573C6.43893 7.36011 6.27446 7.27219 6.14536 7.1431C6.01627 7.014 5.92835 6.84953 5.89274 6.67047C5.85712 6.49141 5.8754 6.30581 5.94527 6.13714C6.01513 5.96847 6.13344 5.8243 6.28524 5.72287C6.43704 5.62145 6.61551 5.56731 6.79808 5.56731C7.04289 5.56731 7.27768 5.66456 7.45079 5.83767C7.6239 6.01078 7.72115 6.24557 7.72115 6.49038Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.88 2H3.12C2.5 2 2 2.5 2 3.12V16.87C2 17.49 2.5 17.99 3.12 17.99H16.87C17.49 17.99 17.99 17.49 17.99 16.87V3.12C17.99 2.5 17.49 2 16.87 2H16.88ZM17 16.88C17 16.95 16.94 17 16.88 17H3.12C3.05 17 3 16.94 3 16.88V3.12C3 3.05 3.06 3 3.12 3H16.87C16.94 3 16.99 3.06 16.99 3.12V16.87L17 16.88Z"
            fill={color}
          />
          <path
            d="M6.88 8.25C6.6 8.25 6.38 8.47 6.38 8.75V13.75C6.38 14.03 6.6 14.25 6.88 14.25C7.16 14.25 7.38 14.03 7.38 13.75V8.75C7.38 8.47 7.16 8.25 6.88 8.25Z"
            fill={color}
          />
          <path
            d="M9.88 8.87V8.75C9.88 8.47 9.66 8.25 9.38 8.25C9.1 8.25 8.88 8.47 8.88 8.75V13.75C8.88 14.03 9.1 14.25 9.38 14.25C9.66 14.25 9.88 14.03 9.88 13.75V10.94C9.88 10.5 10.06 10.06 10.37 9.75C11 9.12 12.13 9.12 12.76 9.75C13.07 10.06 13.25 10.5 13.25 10.94V13.75C13.25 14.03 13.47 14.25 13.75 14.25C14.03 14.25 14.25 14.03 14.25 13.75V10.94C14.25 10.22 13.97 9.55 13.46 9.04C12.51 8.09 10.91 8.04 9.87 8.87H9.88Z"
            fill={color}
          />
          <path
            d="M6.88001 7.18C7.22243 7.18 7.50001 6.90242 7.50001 6.56C7.50001 6.21759 7.22243 5.94 6.88001 5.94C6.53759 5.94 6.26001 6.21759 6.26001 6.56C6.26001 6.90242 6.53759 7.18 6.88001 7.18Z"
            fill={color}
          />
        </svg>
      );
    case "32Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 5C3 3.89543 3.89543 3 5 3H27C28.1046 3 29 3.89543 29 5V27C29 28.1046 28.1046 29 27 29H5C3.89543 29 3 28.1046 3 27V5ZM27 5H5V27H27V5ZM15 13C15.4751 13 15.8727 13.3313 15.9747 13.7754C16.7146 13.2737 17.5932 13 18.5 13C19.6935 13 20.8381 13.4741 21.682 14.318C22.5259 15.1619 23 16.3065 23 17.5V22C23 22.5523 22.5523 23 22 23C21.4477 23 21 22.5523 21 22V17.5C21 16.837 20.7366 16.2011 20.2678 15.7322C19.7989 15.2634 19.163 15 18.5 15C17.837 15 17.2011 15.2634 16.7322 15.7322C16.2634 16.2011 16 16.837 16 17.5V22C16 22.5523 15.5523 23 15 23C14.4477 23 14 22.5523 14 22V17.5V14C14 13.4477 14.4477 13 15 13ZM12 14C12 13.4477 11.5523 13 11 13C10.4477 13 10 13.4477 10 14V22C10 22.5523 10.4477 23 11 23C11.5523 23 12 22.5523 12 22V14ZM12.5 10.5C12.5 11.3284 11.8284 12 11 12C10.1716 12 9.5 11.3284 9.5 10.5C9.5 9.67157 10.1716 9 11 9C11.8284 9 12.5 9.67157 12.5 10.5Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default LinkedinLogoIcon;
